/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import {
	AddressSummaryFragmentDoc,
	AddressFragmentDoc
} from '../Address/Address.hook';
import { HcoSummaryFragmentDoc } from '../Hco/HCOSummary.hook';
import { NotFoundErrorFragmentDoc, PaginationFragmentDoc } from '../core.hook';
import { ParentAffiliationFragmentDoc } from '../Affiliation/Affiliation.hook';
import { LicenseFragmentDoc } from '../License/License.hook';
export type HcpSummaryFragment = {
	__typename?: 'HCP';
	vid_V: string;
	veevaid_V: string;
	statusCda_V?: string | null;
	statusCda_VId?: string | null;
	firstNameCda_V?: string | null;
	firstNameIntl_V?: string | null;
	middleNameCda_V?: string | null;
	middleNameIntl_V?: string | null;
	lastNameCda_V?: string | null;
	lastNameIntl_V?: string | null;
	nickname_V?: string | null;
	prefixCda_V?: string | null;
	suffixCda_V?: string | null;
	allDegreeCda_V?: string | null;
	degree1Cda_V?: string | null;
	hcpTypeCda_V?: string | null;
	hcpType?: {
		__typename?: 'HCPType';
		id: string;
		name: string;
		count: number;
	} | null;
	hcpSpecialties: Array<{
		__typename?: 'HCPSpecialty';
		primary: boolean;
		specialty: {
			__typename?: 'Specialty';
			id: string;
			name: string;
			specialtyGroup: {
				__typename?: 'SpecialtyGroup';
				id: string;
				name: string;
			};
		};
	}>;
	addresses: Array<{
		__typename?: 'Address';
		vid_V: string;
		primaryCda_V?: boolean | null;
		cityCda_V?: string | null;
		cityIntl_V?: string | null;
		stateCda_V?: string | null;
		countryCda_V?: string | null;
		streetAddress1Cda_V?: string | null;
		streetAddress1Intl_V?: string | null;
		postalCodeCda_V?: string | null;
		postalCodeIntl_V?: string | null;
	}>;
};

export type EmailDetails_EmailValue_Fragment = {
	__typename?: 'EmailValue';
	value: string;
};

export type EmailDetails_Forbidden_Fragment = {
	__typename?: 'Forbidden';
	message: string;
};

export type EmailDetailsFragment =
	| EmailDetails_EmailValue_Fragment
	| EmailDetails_Forbidden_Fragment;

export type HcpFragment = {
	__typename?: 'HCP';
	countryId?: string | null;
	gender_V?: string | null;
	birthYear_V?: number | null;
	languageCda_V?: string | null;
	hcpStatus_V?: string | null;
	nhidCda_V?: string | null;
	nhid2_V?: string | null;
	officePhoneCda_V?: string | null;
	phone2_V?: string | null;
	emailCda_V?: string | null;
	faxCda_V?: string | null;
	websiteCda_V?: string | null;
	emailCount: number;
	inactiveAffiliationCount: number;
	gradSchool_V?: string | null;
	gradYear_V?: number | null;
	prescriberCda_V?: boolean | null;
	telehealth_V?: boolean | null;
	inCurrentPecos_V?: boolean | null;
	vid_V: string;
	veevaid_V: string;
	statusCda_V?: string | null;
	statusCda_VId?: string | null;
	firstNameCda_V?: string | null;
	firstNameIntl_V?: string | null;
	middleNameCda_V?: string | null;
	middleNameIntl_V?: string | null;
	lastNameCda_V?: string | null;
	lastNameIntl_V?: string | null;
	nickname_V?: string | null;
	prefixCda_V?: string | null;
	suffixCda_V?: string | null;
	allDegreeCda_V?: string | null;
	degree1Cda_V?: string | null;
	hcpTypeCda_V?: string | null;
	email?:
		| { __typename?: 'EmailValue'; value: string }
		| { __typename?: 'Forbidden'; message: string }
		| null;
	email2?:
		| { __typename?: 'EmailValue'; value: string }
		| { __typename?: 'Forbidden'; message: string }
		| null;
	email3?:
		| { __typename?: 'EmailValue'; value: string }
		| { __typename?: 'Forbidden'; message: string }
		| null;
	email4?:
		| { __typename?: 'EmailValue'; value: string }
		| { __typename?: 'Forbidden'; message: string }
		| null;
	email5?:
		| { __typename?: 'EmailValue'; value: string }
		| { __typename?: 'Forbidden'; message: string }
		| null;
	localHcpType?: {
		__typename?: 'LocalHCPType';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	hcpReasonStatus?: {
		__typename?: 'HCPReasonStatus';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	primaryLocalSpecialty?: {
		__typename?: 'LocalSpecialty';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	secondaryLocalSpecialty?: {
		__typename?: 'LocalSpecialty';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	localSpecialties: Array<{
		__typename?: 'LocalSpecialty';
		code: string;
		name: string;
		localizedName?: string | null;
	}>;
	primaryAffiliation?:
		| {
				__typename?: 'HCO';
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| { __typename?: 'ResourceNotFound'; message: string }
		| null;
	mainOrganization?:
		| {
				__typename?: 'HCO';
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| { __typename?: 'ResourceNotFound'; message: string }
		| null;
	topOrganization?:
		| {
				__typename?: 'HCO';
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| { __typename?: 'ResourceNotFound'; message: string }
		| null;
	affiliations: {
		__typename?: 'HCPAffiliationsResults';
		results: Array<{
			__typename?: 'ParentHCO';
			vid_V: string;
			classOfWork_V?: string | null;
			isPrimaryRelationship_V?: boolean | null;
			parentHcoStatus_VId?: string | null;
			childVeevaid_V?: string | null;
			parentVeevaid_V?: string | null;
			jobTitle_V?: string | null;
			parentHco:
				| {
						__typename?: 'HCO';
						officePhoneCda_V?: string | null;
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							streetAddress2Cda_V?: string | null;
							streetAddress2Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
							postalCodeFullUs_V?: string | null;
							cbsa_V?: string | null;
							latitudeCda_V?: number | null;
							longitudeCda_V?: number | null;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							subStateAdminUnit_V?: string | null;
							businessCda_V?: boolean | null;
							dpvConfirmedIndicator_V?: string | null;
							buildingIdentifier_V?: string | null;
							phoneCda_V?: string | null;
							faxCda_V?: string | null;
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							hospitalCampus?:
								| {
										__typename?: 'HCO';
										vid_V: string;
										veevaid_V: string;
										statusCda_V?: string | null;
										statusCda_VId?: string | null;
										hcoNameCda_V?: string | null;
										hcoNameShort_V?: string | null;
										hcoNameEnglish_V?: string | null;
										hcoNameIntl_V?: string | null;
										hcoTypeCda_V?: string | null;
										addresses: Array<{
											__typename?: 'Address';
											vid_V: string;
											primaryCda_V?: boolean | null;
											cityCda_V?: string | null;
											cityIntl_V?: string | null;
											stateCda_V?: string | null;
											countryCda_V?: string | null;
											streetAddress1Cda_V?: string | null;
											streetAddress1Intl_V?: string | null;
											postalCodeCda_V?: string | null;
											postalCodeIntl_V?: string | null;
										}>;
										hcoType?: {
											__typename?: 'HCOType';
											id: string;
											name: string;
										} | null;
								  }
								| { __typename?: 'ResourceNotFound'; message: string }
								| null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
				  }
				| { __typename?: 'ResourceNotFound'; message: string };
			relationshipType?: {
				__typename?: 'RelationshipType';
				code: string;
				name: string;
			} | null;
		}>;
		paginationMetadata: {
			__typename?: 'PaginationMetadata';
			total: number;
			page: number;
			pageSize: number;
			totalPages: number;
		};
	};
	addresses: Array<{
		__typename?: 'Address';
		streetAddress1Cda_V?: string | null;
		streetAddress1Intl_V?: string | null;
		streetAddress2Cda_V?: string | null;
		streetAddress2Intl_V?: string | null;
		postalCodeCda_V?: string | null;
		postalCodeIntl_V?: string | null;
		postalCodeFullUs_V?: string | null;
		cbsa_V?: string | null;
		latitudeCda_V?: number | null;
		longitudeCda_V?: number | null;
		statusCda_V?: string | null;
		statusCda_VId?: string | null;
		subStateAdminUnit_V?: string | null;
		businessCda_V?: boolean | null;
		dpvConfirmedIndicator_V?: string | null;
		buildingIdentifier_V?: string | null;
		phoneCda_V?: string | null;
		faxCda_V?: string | null;
		vid_V: string;
		primaryCda_V?: boolean | null;
		cityCda_V?: string | null;
		cityIntl_V?: string | null;
		stateCda_V?: string | null;
		countryCda_V?: string | null;
		hospitalCampus?:
			| {
					__typename?: 'HCO';
					vid_V: string;
					veevaid_V: string;
					statusCda_V?: string | null;
					statusCda_VId?: string | null;
					hcoNameCda_V?: string | null;
					hcoNameShort_V?: string | null;
					hcoNameEnglish_V?: string | null;
					hcoNameIntl_V?: string | null;
					hcoTypeCda_V?: string | null;
					addresses: Array<{
						__typename?: 'Address';
						vid_V: string;
						primaryCda_V?: boolean | null;
						cityCda_V?: string | null;
						cityIntl_V?: string | null;
						stateCda_V?: string | null;
						countryCda_V?: string | null;
						streetAddress1Cda_V?: string | null;
						streetAddress1Intl_V?: string | null;
						postalCodeCda_V?: string | null;
						postalCodeIntl_V?: string | null;
					}>;
					hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
			  }
			| { __typename?: 'ResourceNotFound'; message: string }
			| null;
	}>;
	licenses: Array<{
		__typename?: 'License';
		vid_V: string;
		typeValue_VId?: string | null;
		bestStateLicense_V?: boolean | null;
		body_V?: string | null;
		collabAgreeRequired_V?: string | null;
		comprehensivePrescriptiveAuthority_V?: string | null;
		comprehensiveSampleEligibility_V?: string | null;
		ctrlSubstancePrescriptive_V?: string | null;
		ctrlSubstanceSample_V?: string | null;
		deaBusinessActivityCode_V?: string | null;
		deaPaymentIndicator_V?: string | null;
		drugSchedule_V?: string | null;
		expirationDate_V?: any | null;
		gracePeriod_V?: any | null;
		licenseCertification_V?: string | null;
		licenseDegree_V?: string | null;
		licenseEligibility_V?: string | null;
		licenseNumber_V?: string | null;
		licenseStatusCondition_V?: string | null;
		licenseStatus_V?: string | null;
		licenseSubtype_V?: string | null;
		rxaEligible_V?: string | null;
		sourceAddress_V?: string | null;
		type_V?: string | null;
		address?: {
			__typename?: 'Address';
			streetAddress1Cda_V?: string | null;
			streetAddress1Intl_V?: string | null;
			streetAddress2Cda_V?: string | null;
			streetAddress2Intl_V?: string | null;
			postalCodeCda_V?: string | null;
			postalCodeIntl_V?: string | null;
			postalCodeFullUs_V?: string | null;
			cbsa_V?: string | null;
			latitudeCda_V?: number | null;
			longitudeCda_V?: number | null;
			statusCda_V?: string | null;
			statusCda_VId?: string | null;
			subStateAdminUnit_V?: string | null;
			businessCda_V?: boolean | null;
			dpvConfirmedIndicator_V?: string | null;
			buildingIdentifier_V?: string | null;
			phoneCda_V?: string | null;
			faxCda_V?: string | null;
			vid_V: string;
			primaryCda_V?: boolean | null;
			cityCda_V?: string | null;
			cityIntl_V?: string | null;
			stateCda_V?: string | null;
			countryCda_V?: string | null;
			hospitalCampus?:
				| {
						__typename?: 'HCO';
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
				  }
				| { __typename?: 'ResourceNotFound'; message: string }
				| null;
		} | null;
	}>;
	hcpType?: {
		__typename?: 'HCPType';
		id: string;
		name: string;
		count: number;
	} | null;
	hcpSpecialties: Array<{
		__typename?: 'HCPSpecialty';
		primary: boolean;
		specialty: {
			__typename?: 'Specialty';
			id: string;
			name: string;
			specialtyGroup: {
				__typename?: 'SpecialtyGroup';
				id: string;
				name: string;
			};
		};
	}>;
};

export type HcpAffiliationLinkFragment = {
	__typename?: 'HCP';
	affiliations: {
		__typename?: 'HCPAffiliationsResults';
		results: Array<{
			__typename?: 'ParentHCO';
			vid_V: string;
			isPrimaryRelationship_V?: boolean | null;
			parentHco:
				| {
						__typename?: 'HCO';
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
				  }
				| { __typename?: 'ResourceNotFound'; message: string };
		}>;
	};
};

export const HcpSummaryFragmentDoc = gql`
	fragment HCPSummary on HCP {
		vid_V
		veevaid_V
		statusCda_V
		statusCda_VId
		firstNameCda_V
		firstNameIntl_V
		middleNameCda_V
		middleNameIntl_V
		lastNameCda_V
		lastNameIntl_V
		nickname_V
		prefixCda_V
		suffixCda_V
		allDegreeCda_V(includePrimary: true)
		degree1Cda_V
		hcpTypeCda_V
		hcpType {
			id
			name
			count
		}
		hcpSpecialties {
			specialty {
				id
				name
				specialtyGroup {
					id
					name
				}
			}
			primary
		}
		addresses(includeInactive: true) {
			...AddressSummary
		}
	}
	${AddressSummaryFragmentDoc}
`;
export const EmailDetailsFragmentDoc = gql`
	fragment EmailDetails on EmailValueForbidden {
		... on Forbidden {
			message
		}
		... on EmailValue {
			value
		}
	}
`;
export const HcpFragmentDoc = gql`
	fragment HCP on HCP {
		...HCPSummary
		countryId
		gender_V
		birthYear_V
		languageCda_V
		hcpStatus_V
		nhidCda_V
		nhid2_V
		officePhoneCda_V
		phone2_V
		emailCda_V
		faxCda_V
		websiteCda_V
		email {
			...EmailDetails
		}
		email2 {
			...EmailDetails
		}
		email3 {
			...EmailDetails
		}
		email4 {
			...EmailDetails
		}
		email5 {
			...EmailDetails
		}
		emailCount
		localHcpType {
			code
			name
			localizedName
		}
		hcpReasonStatus {
			code
			name
			localizedName
		}
		primaryLocalSpecialty {
			code
			name
			localizedName
		}
		secondaryLocalSpecialty {
			code
			name
			localizedName
		}
		localSpecialties {
			code
			name
			localizedName
		}
		primaryAffiliation {
			...HCOSummary
			...NotFoundError
		}
		mainOrganization {
			...HCOSummary
			...NotFoundError
		}
		topOrganization {
			...HCOSummary
			...NotFoundError
		}
		inactiveAffiliationCount
		affiliations(
			payload: { includeInactive: false }
			paginationInput: { page: 1, pageSize: $affiliationsPageSize }
		) {
			results {
				...ParentAffiliation
			}
			paginationMetadata {
				...Pagination
			}
		}
		addresses(includeInactive: true) {
			...Address
		}
		licenses {
			...License
		}
		gradSchool_V
		gradYear_V
		prescriberCda_V
		telehealth_V
		inCurrentPecos_V
	}
	${HcpSummaryFragmentDoc}
	${EmailDetailsFragmentDoc}
	${HcoSummaryFragmentDoc}
	${NotFoundErrorFragmentDoc}
	${ParentAffiliationFragmentDoc}
	${PaginationFragmentDoc}
	${AddressFragmentDoc}
	${LicenseFragmentDoc}
`;
export const HcpAffiliationLinkFragmentDoc = gql`
	fragment HCPAffiliationLink on HCP {
		affiliations(
			payload: { includeInactive: true }
			paginationInput: { page: 1, pageSize: 100 }
		) {
			results {
				... on ParentHCO {
					vid_V
					isPrimaryRelationship_V
					parentHco {
						...HCOSummary
						...NotFoundError
					}
				}
			}
		}
	}
	${HcoSummaryFragmentDoc}
	${NotFoundErrorFragmentDoc}
`;
